<se-fe-spinner [seFeDataSize]="950" [seFeDataCenter]="true"></se-fe-spinner>
